<template>
  <div id="order_buil_research">
    <table>
      <thead>
        <tr>
          <th class="order_th" colspan="5"><font color="ffffff">事前現場調査情報</font></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="order_td" colspan="3">施主名（物件名）</td>
          <td colspan="2">{{builResrchData.businessName}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">調査物件名</td>
          <td colspan="2">{{builResrchData.building}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">立会人氏名</td>
          <td colspan="2">{{builResrchData.userLastName}} {{builResrchData.userFirstName}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">立会人氏名（カナ）</td>
          <td colspan="2">{{builResrchData.userLastNameKana}} {{builResrchData.userFirstNameKana}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">立会人電話番号</td>
          <td colspan="2">{{builResrchData.tel}}</td>
        </tr>
        <tr>
          <td class="order_td" rowspan="2">事前現場調査先</td>
          <td class="order_td" colspan="2">郵便番号</td>
          <td colspan="2">{{builResrchData.postcd}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="2">住所</td>
          <td colspan="2">{{builResrchData.address}}</td>
        </tr>
        <tr>
          <td class="order_td" rowspan="2">専有部分</td>
          <td class="order_td" colspan="2">調査場所</td>
          <td colspan="2">
            <span class="text" v-for="(text, index) in privateAreaResearchList" :key="'pri-resrch' + index">{{text}}</span>
          </td>
        </tr>
        <tr>
          <td class="order_td" colspan="2">その他確認事項</td>
          <td colspan="2">{{builResrchData.resrchPriConfComment}}</td>
        </tr>
        <tr>
          <td class="order_td" rowspan="2">共用部分</td>
          <td class="order_td" colspan="2">調査場所</td>
          <td colspan="2">
            <span class="text" v-for="(text, index) in publicAreaResearchList" :key="'pub-resrch' + index">{{text}}</span>
          </td>
        </tr>
        <tr>
          <td class="order_td" colspan="2">その他確認事項</td>
          <td colspan="2">{{builResrchData.resrchPubConfComment}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">その他コメント</td>
          <td colspan="2">{{builResrchData.resrchOtherComment}}</td>
        </tr>
        <tr>
          <td class="order_td" rowspan="3">事前調査日</td>
          <td class="order_td" colspan="2">事前現場調査日</td>
          <td colspan="2">{{getDate(builResrchData.resrchDate, builResrchData.resrchDateType)}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="2">第一希望日</td>
          <td colspan="2">{{getDate(builResrchData.resrchPref1, builResrchData.resrchPref1Type)}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="2">第二希望日</td>
          <td colspan="2">{{getDate(builResrchData.resrchPref2, builResrchData.resrchPref2Type)}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">日程調整を希望の場合</td>
          <td colspan="2">{{builResrchData.resrchScheduleComment}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">事前現場調査依頼者の立ち会い</td>
          <td colspan="2">{{isObserver}}</td>
        </tr>
        <tr>
          <td class="order_td" colspan="3">調査先への入力方法</td>
          <td colspan="2">{{builResrchData.resrchEntranceComment}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'OrderDetail',
  components: {
  },
  props: {
    builResrchData: Object
  },
  methods: {
    getDate: function (date, type) {
      let time = moment(date).format('YYYY/MM/DD')
      if (type === 0) time += ' 時間指定なし'
      if (type === 1) time += ' AM 9:00 ～ 13:00'
      if (type === 2) time += ' PM 13:00 ～ 17:00'
      return time
    }
  },
  computed: {
    privateAreaResearchList: function () {
      if (!this.builResrchData) return ''
      let list = []
      if (this.builResrchData.resrchPriPositionFlg) list.push('設置場所の採寸')
      if (this.builResrchData.resrchPriGroundFlg) list.push('設置場所の下地確認')
      if (this.builResrchData.resrchPriPlugFlg) list.push('コンセント・PS等壁設定情報')
      if (this.builResrchData.resrchPriCeilingFlg) list.push('照明・自火報等天井設置物確認')
      if (this.builResrchData.resrchPriCarryRouteFlg) list.push('搬入経路の有効寸法確認')
      return list
    },
    publicAreaResearchList: function () {
      if (!this.builResrchData) return ''
      let list = []
      if (this.builResrchData.resrchPubTruckParkFlg) list.push('トラック停車位置')
      if (this.builResrchData.resrchPubCarryRouteFlg) list.push('搬入経路')
      if (this.builResrchData.resrchPubElevatorFlg) list.push('エレベータサイズ')
      if (this.builResrchData.resrchPubRequestFlg) list.push('搬入施工等の事前申請の有無')
      if (this.builResrchData.resrchPubCuringFlg) list.push('共用部養生の有無')
      if (this.builResrchData.resrchPubParkingFlg) list.push('搬入経路の有効寸法確認')
      return list
    },
    isObserver: function () {
      if (this.builResrchData.resrchObserver) return 'あり'
      return 'なし'
    }
  }
}
</script>
<style src="../../css/order/orderDetail.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.text {
  display: inline-block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/order/OrderBuilResearch.vue